import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=4237b39c&"
import script from "./TaskManager.vue?vue&type=script&lang=js&"
export * from "./TaskManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports